import PSY_URI from '@/assets/Utils/api/url-const'
import { GET ,POST } from '@/assets/Utils/api/http';
/*
* 新闻动态详情
* @parmm{
*   id}
* */
export const GetPositonDetail = (id)=>{
  return GET(PSY_URI.POSITON_DETAIL+id)
}
